import axios from 'axios';
// import { Notification, MessageBox, Message, Loading } from 'element-ui';
import store from '@/store';
import {Notify, Dialog, Toast} from 'vant';
import 'vant/lib/notify/style';
import {
    getExpiresIn,
    getRandomNum,
    getToken,
    reBuildRequestConfig,
    setExpiresIn,
    setToken,
} from '@/utils/auth';
import errorCode from '@/utils/errorCode';
import {tansParams, blobValidate} from '@/utils/ruoyi';
// import cache from '@/plugins/cache';
// import { saveAs } from 'file-saver';
import {XXTEA} from '@/utils/xxtea.min';
// import { refreshToken } from '@/api/login';
// import moment from 'moment-timezone';

const Base64 = require('js-base64').Base64;

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = {show: false};
const _baseUrl = window.config.baseUrl;
const isProduction = process.env.NODE_ENV === 'production';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: isProduction ? _baseUrl : '',
    // 超时
    timeout: 10000,
});

let keyarr = [];

// request拦截器
let isRefresh = false;
service.interceptors.request.use(
    (config) => {
        //获取当前系统时间
        console.log(config);
        let curent = new Date().getTime();
        const newConfig = JSON.parse(JSON.stringify(config));
        console.log('参数', newConfig.data);
        //获取token过期时间
        let expireTime = getExpiresIn();
        let token = getToken();
        if (expireTime > 0 && token) {
            let minMx = (expireTime - curent) / 1000 / 60;
            //如果token离过期差120分钟，刷新token
            if (minMx < 120) {
                if (!isRefresh) {
                    isRefresh = true;
                    refreshToken()
                        .then((res) => {
                            if (res.code === 200) {
                                //设置新的token和时间
                                setToken(res.data.access_token);
                                setExpiresIn(res.data.expires_in);
                            }
                        })
                        .cache(() => {
                        })
                        .finally(() => {
                            isRefresh = false;
                        });
                }
            }
        }
        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
        // get请求映射params参数
        if (config.method === 'get' && config.params) {
            let url = config.url + '?' + tansParams(config.params);
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }
        if (
            isRepeatSubmit &&
            (config.method === 'post' || config.method === 'put')
        ) {
            const requestObj = {
                url: config.url,
                data:
                    typeof config.data === 'object'
                        ? JSON.stringify(config.data)
                        : config.data,
                time: new Date().getTime(),
            };
            const sessionObj = cache.session.getJSON('sessionObj');
            if (
                sessionObj === undefined ||
                sessionObj === null ||
                sessionObj === ''
            ) {
                cache.session.setJSON('sessionObj', requestObj);
            } else {
                const s_url = sessionObj.url; // 请求地址
                const s_data = sessionObj.data; // 请求数据
                const s_time = sessionObj.time; // 请求时间
                const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
                if (
                    s_data === requestObj.data &&
                    requestObj.time - s_time < interval &&
                    s_url === requestObj.url
                ) {
                    const message = '数据正在处理，请勿重复提交';
                    // console.warn(`[${s_url}]: ` + message)
                    return Promise.reject(new Error(message));
                } else {
                    cache.session.setJSON('sessionObj', requestObj);
                }
            }
        }
        const responseType = (config || {}).responseType;

        keyarr.push(reBuildRequestConfig(config, responseType));
        return config;
    },
    (error) => {
        //console.log(error)
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (res) => {
        const isexport = res.config.responseType;
        // 二进制数据则直接返回
        if (isexport === 'blob' || isexport === 'arraybuffer') {
            let type = res.data.type;
            // 当返回的数据流不是excel时
            if (type === 'text/html') {
                var reader = new FileReader();
                reader.onload = function () {
                    let jsonRes = JSON.parse(reader.result);
                    Toast(jsonRes.msg);
                };
                reader.readAsText(res.data);
                return Promise.reject(new Error('导出异常'));
            }
            return {blob: res.data};
        }
        let functionid = res.config.headers.functionid;
        let keyvalue;
        for (let i = 0; i < keyarr.length; i++) {
            if (functionid == keyarr[i].key1) {
                keyvalue = keyarr[i].key2;
                keyarr.splice(i, 1);
            }
        }
        const ss = XXTEA.decryptFromBase64(res.data, keyvalue);

        res = JSON.parse(ss);
        // 未设置状态码则默认成功状态
        const code = res.code || 200;
        // 获取错误信息
        console.log('接口返回结果', JSON.parse(JSON.stringify(res)));
        const msg = errorCode[code] || res.msg || errorCode['default'];
        if (code !== 200 && code !== 1) {
            if (code === 401) {
                if (!isRelogin.show) {
                    isRelogin.show = true;
                    Dialog.confirm({
                        title: '系统提示',
                        message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
                        cancelButtonText: '取消',
                        confirmButtonText: '重新登录',
                    })
                        .then(() => {
                            isRelogin.show = false;
                            store.dispatch('LogOut').then(() => {
                                // 如果是在当游戏页面调用接口过期了，需要提示重新登录，并且跳转也是当前页面
                                if (location.pathname === "/game") {
                                    location.href = '/game';
                                } else {
                                    location.href = '/index';
                                }
                            });
                        })
                        .catch(() => {
                            isRefresh = false;
                        });
                }
            } else if (code === 500) {
                Toast(msg);
            }
            return Promise.reject(new Error(msg || 'error'));
        } else {
            return res;
        }
        // else if (code !== 200 && code !== 1) {
        //       Notify({ type: 'danger', message: msg });
        //       return Promise.reject('error');
        //     } else {

        //     }
    },
    (error) => {
        let {message} = error;
        if (message == 'Network Error') {
            message = '后端接口连接异常';
        } else if (message.includes('timeout')) {
            message = '系统接口请求超时';
        } else if (message.includes('Request failed with status code')) {
            message = '系统接口' + message.substr(message.length - 3) + '异常';
        }
        // Notify({ type: 'danger', message: message, duration: 5 * 1000 });
        Toast(message);
        return Promise.reject(error);
    }
);

// 通用下载方法
export function download(url, params, filename) {
    downloadLoadingInstance = Loading.service({
        text: '正在下载数据，请稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });
    return service
        .post(url, params, {
            transformRequest: [
                (params) => {
                    return tansParams(params);
                },
            ],
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            responseType: 'blob',
        })
        .then(async (data) => {
            const isLogin = await blobValidate(data);
            if (isLogin) {
                const blob = new Blob([data]);
                saveAs(blob, filename);
            } else {
                const resText = await data.text();
                const rspObj = JSON.parse(resText);
                const errMsg =
                    errorCode[rspObj.code] || rspObj.msg || errorCode['default'];
                // Notify({ type: 'danger', message: errMsg });
                Toast(errMsg);
            }
            downloadLoadingInstance.close();
        })
        .catch((r) => {
            console.error(r);
            // Notify({ type: 'danger', message: '下载文件出现错误，请联系管理员！' });
            Toast('下载文件出现错误，请联系管理员');
            downloadLoadingInstance.close();
        });
}

export default service;
